var exports = {
  "kL": "ScopeSheet.module__container___NE11bD",
  "XG": "ScopeSheet.module__scroller___NE11bD",
  "iy": "ScopeSheet.module__optionsContainer___NE11bD",
  "uK": "ScopeSheet.module__option___NE11bD",
  "h4": "ScopeSheet.module__optionSelected___NE11bD",
  "ts": "ScopeSheet.module__optionLeft___NE11bD",
  "H9": "ScopeSheet.module__optionIcon___NE11bD",
  "AJ": "ScopeSheet.module__optionIconSelected___NE11bD",
  "re": "ScopeSheet.module__optionText___NE11bD",
  "ed": "ScopeSheet.module__optionLabel___NE11bD",
  "tD": "ScopeSheet.module__optionLabelSelected___NE11bD",
  "q3": "ScopeSheet.module__optionDescription___NE11bD",
  "oE": "ScopeSheet.module__checkIcon___NE11bD",
};

module.exports = exports;
